import Vue from 'vue'

export default {
    SET_PAGE_TITLE(state, payload) {
        state.pageTitle = payload;
    },
    SET_NAVIGATION(state, payload) {
        state.hasNavigation = payload;
    },
    SET_PAGE_ACTIONS(state, {actions}) {
        if (actions === null){
            // state.defaultActions[0].badge = extra.messages;
            // state.defaultActions[1].badge = extra.tickets;
            state.pageActions = state.defaultActions;
        }
        else
            state.pageActions = actions;
    },
    SET_SIDEBAR(state, payload) {
        state.showSidebar = payload;
    },
    UPDATE_API_DATA(state, payload) {
        state.api = payload;
    },
    UPDATE_USER_DATA(state, payload) {
        Object.keys(payload).forEach(key => {
            state.userData[key] = payload[key];
        });
    },
    SET_LOGIN_REDIRECT_PATH(state, payload) {
        state.loginRedirectPath = payload;
    },
    UPDATE_TOKEN(state, payload) {
        if(payload === null)
            localStorage.removeItem('userToken');
        else
            localStorage.setItem('userToken', payload);

        state.token = payload;
        if (payload === null)
            delete state.api.headers['Authorization'];
        else
            state.api.headers['Authorization'] = "Bearer " + payload;
    },
    SET_API_CACHE(state, {key, params}) {
        if (key.includes("/")) {
            const keyParts = key.split('/');
            if (!(keyParts[0] in state.apiCache))
                state.apiCache[keyParts[0]] = {time: null, data: {}};
            state.apiCache[keyParts[0]]['time'] = params.time;
            state.apiCache[keyParts[0]]['data'][keyParts[1]] = params.data;
        } else
            state.apiCache[key] = params;
    },
    REMOVE_API_CACHE(state, key) {
        Vue.delete(state.apiCache, key)
    },

    SET_SETTINGS(state, payload) {
        state.settings = payload;
    },
    UPDATE_SETTINGS(state, {key, value}){
        state.settings[key] = value;
    }
}